export var StorageDataType;
(function (StorageDataType) {
    StorageDataType["FILE_FROM_URL"] = "FILE_FROM_URL";
    StorageDataType["OBJECT"] = "OBJECT";
    StorageDataType["DIRECTORY"] = "DIRECTORY";
    StorageDataType["FILE_BUFFER"] = "FILE_BUFFER";
})(StorageDataType || (StorageDataType = {}));
//# sourceMappingURL=storageDataType.enum.js.map